import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { FormGroup } from '@angular/forms';
import { addRemoveError } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { isEqual } from 'lodash-es';
import { conclusioniCkHelper, getConclusioniControl } from './helpers/conclusioni-form.helper';

export const conclusioniPropostaScioglimentoRules: FormGroupRules = {
    my_descArt2545Ric: (form: FormGroup) => {
        const my_descArt2545RicControl = getConclusioniControl(form, 'my_SchedaPropostaScioglimento.my_descArt2545Ric');
        const my_ckImpossRaggScopo: string | boolean = getConclusioniControl(form, 'my_SchedaPropostaScioglimento.my_ckImpossRaggScopo').value;
        const my_ckNonPersegScMutua: string | boolean = getConclusioniControl(form, 'my_SchedaPropostaScioglimento.my_ckNonPersegScMutua').value;
        const my_ckNoDepBil2Anni: string | boolean = getConclusioniControl(form, 'my_SchedaPropostaScioglimento.my_ckNoDepBil2Anni').value;
        const my_ckNoAttiGest2Anni: string | boolean = getConclusioniControl(form, 'my_SchedaPropostaScioglimento.my_ckNoAttiGest2Anni').value;
        const checkCk = (ck: string | boolean) => {
            return ck != false && ck != '0';
        };
        const showError =
            isNilOrEmpty(my_descArt2545RicControl.value) &&
            (checkCk(my_ckImpossRaggScopo) || checkCk(my_ckNonPersegScMutua) || checkCk(my_ckNoDepBil2Anni) || checkCk(my_ckNoAttiGest2Anni));
        const errors = my_descArt2545RicControl.errors ? my_descArt2545RicControl.errors : {};

        addRemoveError(showError, errors, 'my_descArt2545Ric', {
            status: REQUIRED_STATUS,
        });

        my_descArt2545RicControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_ckBeniImmobili: (form: FormGroup) => {
        conclusioniCkHelper(form, 'my_SchedaPropostaScioglimento.my_ckBeniImmobili', 'my_CkProvvedimendoDi', 3);
    },

    my_ckBeniMobiliRegistr: (form: FormGroup) => {
        conclusioniCkHelper(form, 'my_SchedaPropostaScioglimento.my_ckBeniMobiliRegistr', 'my_CkProvvedimendoDi', 3);
    },

    my_ckValAttivoNecessLiquid: (form: FormGroup) => {
        conclusioniCkHelper(form, 'my_SchedaPropostaScioglimento.my_ckValAttivoNecessLiquid', 'my_CkProvvedimendoDi', 3);
    },

    my_descRisultUltBilApp: (form: FormGroup) => {
        const my_descRisultUltBilAppControl = getConclusioniControl(form, 'my_SchedaPropostaScioglimento.my_descRisultUltBilApp');
        const my_ckBeniMobiliRegistr: string = getConclusioniControl(form, 'my_SchedaPropostaScioglimento.my_ckBeniMobiliRegistr').value;
        const my_ckValAttivoNecessLiquid: string = getConclusioniControl(form, 'my_SchedaPropostaScioglimento.my_ckValAttivoNecessLiquid').value;
        const my_ckBeniImmobili: string = getConclusioniControl(form, 'my_SchedaPropostaScioglimento.my_ckBeniImmobili').value;
        const my_CkProvvedimendoDi: string = getConclusioniControl(form, 'my_CkProvvedimendoDi').value;
        const showError =
            isNilOrEmpty(my_descRisultUltBilAppControl.value) &&
            my_CkProvvedimendoDi === '3' &&
            (my_ckBeniImmobili === '1' || my_ckBeniMobiliRegistr === '1' || my_ckValAttivoNecessLiquid === '1');
        const errors = my_descRisultUltBilAppControl.errors ? my_descRisultUltBilAppControl.errors : {};

        addRemoveError(showError, errors, 'my_descRisultUltBilApp', {
            status: REQUIRED_STATUS,
        });

        my_descRisultUltBilAppControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_ckPresuppostiArt223: (form: FormGroup) => {
        conclusioniCkHelper(form, 'my_SchedaPropostaScioglimento.my_ckPresuppostiArt223', 'my_CkProvvedimendoDi', 3);
    },
};
